/**
 * Nombre ou montant au format compact du monitoring (`formatCompact`), avec
 * la valeur exacte en infobulle quand l'affichage l'abrège ou l'arrondit.
 */
import React from 'react';
import { Tooltip } from 'antd';
import { useFormat } from './format';

export type CompactValueProps = {
    value: number | string | null | undefined;
    /** Code ISO 4217 pour un montant ; absent pour un comptage. */
    currency?: string;
};

const CompactValue: React.FC<CompactValueProps> = ({ value, currency }) => {
    const f = useFormat();
    const { text, exact } = f.compact(value, currency);
    const shown = (
        <span dir="ltr" style={{ unicodeBidi: 'isolate' }} data-exact={exact ?? undefined} tabIndex={exact ? 0 : undefined}>
            {text}
        </span>
    );
    return exact ? <Tooltip title={exact}>{shown}</Tooltip> : shown;
};

export default CompactValue;
